import Error404 from '@/components/Error404';
import { host } from '@/config';
import { clientsUsingSales } from '@/constants/temp_modularization';
import NotAllowed from '@/modules/core/pages/not-allowed';
import { protectedRoute } from '@/modules/core/root/protected/route';
import { createRoute, redirect } from '@tanstack/react-router';

import { SalesLayout } from './layout';

export const salesRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'sales',
  component: SalesLayout,
  beforeLoad: ({ context }) => {
    if (!context.auth.userIsAdmin()) {
      throw new Error('User is not an admin');
    }
    if (!clientsUsingSales.includes(host)) {
      throw redirect({ to: '/' });
    }
  },
  errorComponent: (error) => {
    if (error instanceof Error && error.message === 'User is not an admin') {
      return <NotAllowed />;
    }

    return <Error404 />;
  },
});
